// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.favorite-btn[data-v-6527b366] {\n    margin-top: 28px;\n}\n", ""]);
// Exports
module.exports = exports;
